module.exports = __webpack_public_path__ + "videos/branding.206fb62.webm";